import React from "react";
import { connect } from "react-redux";
import LoadingBar from "../../../lib/react-redux-loading-bar";


const LookLoadingBar = () => {

  const barWithCounter = (counter) => (
    <div className="look-loading">
      <span className="look-loading__counter">{counter}%</span>
      <div className="look-loading__line">
        <div style={{width: counter + "px"}} className="look-loading__line-fill"/>
      </div>
    </div>
  )

  return <LoadingBar className="loader-counter" renderComponent={barWithCounter} />
};

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LookLoadingBar)
